import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from "@angular/core";
import { ITitrationPreLoadParams } from '../titration-rechner.model';
import { PartnerNamesEnum } from "../../medizinisches-cannabisantrag";


@Component({
    selector: 'app-titration-rechner-popup',
    templateUrl: "./titration-rechner-popup.component.html",
    styleUrls: ["./titration-rechner-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationRechnerPopupComponent implements OnInit {
    @Input() partnerName: string = "";
    PartnerNamesEnum = PartnerNamesEnum;
    @Output() onBtnCLick: EventEmitter<ITitrationPreLoadParams> = new EventEmitter();

    FachrichtungVal: string = "";
    FachrichtungInput: string = "";
    BundeslandVal: string = "";
    BundeslandInput: string = "";

    showAlertInfo: boolean = false;

    FachrichtungList: string[] = [
        "Apotheke",
        "Allgemeinmedizin",
        "Anästhesiologie",
        "Chirurgie",
        "Dermatologie",
        "Gynäkologie",
        "Innere Medizin",
        "Neurologie",
        "Orthopädie und Unfallchirurgie",
        "Physikalische und Rehabilitative Medizin",
        "Psychiatrie und Psychotherapie",
        "Andere Fachrichtung"
    ];

    BundeslandList: string[] = [
        "Baden-Württemberg",
        "Bayern",
        "Berlin",
        "Brandenburg",
        "Bremen",
        "Hamburg",
        "Hessen",
        "Mecklenburg-Vorpommern",
        "Niedersachsen",
        "Nordrhein-Westfalen",
        "Rheinland-Pfalz",
        "Saarland",
        "Sachsen",
        "Sachsen-Anhalt",
        "Schleswig-Holstein",
        "Thüringen",
        "Schweiz",
        "Österreich",
        "Anderes Land"
    ];


    get fullYear() {
        return new Date().getFullYear();
    }

    get showFachrichtungInput() {
        return this.FachrichtungVal == "Andere Fachrichtung";
    }

    get showBundeslandInput() {
        return this.BundeslandVal == "Anderes Land";
    }

    constructor() {

    }

    ngOnInit(): void {

    }

    submitForm() {
        this.showAlertInfo = false;
        let valid: boolean = false;
        if (this.BundeslandVal.length && this.FachrichtungVal.length) {
            valid = true;
            if ((this.showFachrichtungInput && this.FachrichtungInput.trim().length < 3) || (this.showBundeslandInput && this.BundeslandInput.trim().length < 3)) {
                valid = false;
            }
        }
        if (valid) {
            this.onBtnCLick.emit({
                Fachrichtung: this.FachrichtungVal,
                FachrichtungText: this.FachrichtungInput,
                Bundesland: this.BundeslandVal,
                BundeslandText: this.BundeslandInput,
            });
        } else {
            this.showAlertInfo = true;
        }
    }


}
